import React from "react";
import { Box, ThemeProvider, Typography } from "@mui/material";
import { baseTheme } from "mui-theme";

interface Props {
  value: string;
}

const SectionTitle: React.FC<Props> = ({ value }) => {
  return (
    <ThemeProvider theme={baseTheme}>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "primary.dark",
          padding: "10px 0",
        }}
      >
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: "bold",
            color: "primary.contrastText",
            marginLeft: "20px",
          }}
        >
          {value}
        </Typography>
      </Box>
    </ThemeProvider>
  );
};

export default SectionTitle;
